import React from "react";
import ReactDOM from "react-dom";
/* Asynchronous calls */
import axios from "axios";
import swal from "sweetalert";
import "./index.css";
/** Material Design */
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
/** Bootstrap table next */
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";


/** Semantic UI css  for training Feedback */
import "semantic-ui-css-offline";



/* Routes */
import Router from "./Components/Router";



/* Redux Store */ 
import store from "./Components/redux_components/store";
/* Redux Provider */
import { Provider } from "react-redux";


// import registerServiceWorker from "./registerServiceWorker";
/* Common axios response handler */
axios.interceptors.response.use(null, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("Network error", error);
    swal({
      title: `Message`,

      padding: "3em",

      text:
        " NHP Server is either busy or under maintenance. Please revisit again",
    });
  }
);
/*** Comment in Development Mode */

//console.log = function () { }
console.warn = function () { };
console.error = function () { };


ReactDOM.render(
  <Provider store={store}>
    <Router />
  </Provider>,
  document.getElementById("root")
);
// registerServiceWorker();
